import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { applyMiddleware, compose, combineReducers, createStore } from 'redux';
import pageReducer from './store/reducers/pages';
import listReducer from './store/reducers/projectLists';
import projectReducer from './store/reducers/projects';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

const isDevEnv = process.env.REACT_APP_BUILDTYPE === 'DEVELOPMENT';
const composeEnhancers = isDevEnv? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose;

const rootReducer = combineReducers({
  pages: pageReducer,
  projectLists: listReducer,
  projects: projectReducer
});

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)))

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
